import React from 'react';
import { Radio, Input, Form } from 'antd';
import './questioncard.scss';
import { useEffect } from 'react';
import {  useTranslation } from 'soxo-bootstrap-core';

export default function QuestionCard({ questionOne, radio, radioLabels = [], input, answer, isEditable, record, onChange }) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    useEffect(() => {
        // form.resetFields(); // Clear previous values when switching questions
        form.setFieldsValue({ radio: record.values, input: record.remarks }); // Set correct radio value
    }, [record]);

    /**
     * Handles the change event for a form input and updates the value if editable.
     *
     */
    function handleChange(e, value) {
        if (isEditable) {
            const newAnswer = e.target.value;
            onChange?.({ ...value, values: newAnswer }); // Pass updated record
        }
    }
    return (
        <div className="question-card">
            <p>{questionOne}</p>
            <Form form={form}>
                {/* Radio Buttons */}
                {radio && radioLabels.length > 0 && isEditable ? (
                    <Form.Item name={'radio'}>
                        <Radio.Group
                            // Controlled value for radio buttons
                            // onChange={handleRadioChange} // Handle radio change
                            className="d-flex gap-20"
                            onChange={(e) => {
                                handleChange(e, record);
                            }}
                        >
                            {radioLabels.map((label, index) => (
                                <Radio key={index} value={label}>
                                    {label}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </Form.Item>
                ) : (
                    <Radio.Group value={answer} className="d-flex gap-20">
                        {radioLabels.map((label, index) => (
                            <Radio key={index} value={label}>
                                {label}
                            </Radio>
                        ))}
                    </Radio.Group>
                )}

                {/* Text Input */}
                {input && (
                    <Form.Item
                        name={'input'}
                        rules={[
                            {
                                pattern: /^[a-zA-Z\s.,]*$/g,
                                message: t('Please Enter Valid Name!'),
                            },
                            {
                                max: 1000,
                                message: t('Length cannot exceed 1000 characters !'),
                            },
                        ]}
                    >
                        <Input
                            value={answer} // Controlled value for the input field
                            disabled={isEditable ? false : true}
                            // onChange={handleInputChange} // Handle input change
                            // placeholder={'Enter your answer'}
                            onChange={(e) => {
                                handleChange(e, record);
                            }}
                        />
                    </Form.Item>
                )}
            </Form>
        </div>
    );
}
